import React from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const OverviewTab = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h6" gutterBottom>Sending Requests</Typography>
            <Typography variant="body1">
                HawkClient allows you to send REST and GraphQL requests with ease.
                Choose your method (GET, POST, PUT, etc.), enter the endpoint, and configure
                body, headers, and query params as needed. Once ready, click "Send" to view
                the response including status, headers, and body.
            </Typography>
            <img
                src="/send-requests/SendRequest.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
        </Box>
    )
};

export default OverviewTab;
